import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import LoadingBase from '@blade-sxp/tools/pages/one-one/components/loading-base.vue';
let Loading = class Loading extends Vue {
};
Loading = __decorate([
    Component({
        name: 'loading',
        components: { LoadingBase },
        i18n: {
            messages: {
                en: {
                    compare: 'Comparing, please wait',
                },
                zh: {
                    compare: '正在比对，请稍后',
                }
            }
        }
    })
], Loading);
export default Loading;
